import { useContext } from "react";
import { useHistory } from "react-router-dom";
import * as Icon from "react-bootstrap-icons";

import Button from "../Input/Button";
import Context from "../../../context";

import logo from "../../../assets/images/neer_logo.svg";
import ModalButton from "../Modals/ModalButton";

export default function Header({ children }) {
  const history = useHistory();
  const { contextState, setContextState } = useContext(Context);
  let account = contextState.currentAccount;

  return (
    <div className="header-layout">
      <div className="header header-container">
        <div className="header-wrapper">
          <div
            className="header-hamburger"
            onClick={() => {
              setContextState({ ...contextState, isSidebarOpen: true });
            }}>
            <Icon.List height={24} width={24} />
          </div>
          <div className="header-account-detail">
            <p>{account?.customerName}</p>
            <p>Customer #: {account?.customerNumber}</p>
            <p>
              {account?.customerAddress}
              {account?.address1}
              {account?.address2}
              {account?.cityStateZip}
            </p>
          </div>
          <div className="header-logo">
            <img className="logo-image" alt="" src={logo} />
          </div>
          <div className="header-buttons-wrapper">
            {contextState.accounts.length > 1 && (
              <div className="form-field">
                <Button
                  className="btn-fluid btn--blue btn--bordered all-accounts-btn"
                  onClick={() => {
                    history.push("/");
                    setContextState({...contextState, detailActivePage: 'overview'})
                  }}
                  text="All Accounts"
                  icon={<Icon.Building className="header-btn-icon" />}
                />
              </div>
            )}
            <div className="form-field">
              <Button
                className="btn-fluid btn--green btn--bordered"
                onClick={() => {
                  history.push(
                    `/account/${contextState.currentAccountId}/detail`
                  );
                  setContextState({
                    ...contextState,
                    detailActivePage: "contact",
                  });
                }}
                text="Contact"
                icon={<Icon.Telephone className="header-btn-icon" />}
              />
            </div>
            <div className="form-field">
              <ModalButton
                className="btn btn--red btn--bordered"
                modal="gasLeak"
                payload={"payload"}
                icon={<Icon.ExclamationTriangle className="header-btn-icon" />}>
                Gas Leak
              </ModalButton>
            </div>
          </div>
        </div>
      </div>
      {children}
    </div>
  );
}
